import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useRefferalData } from "../../../hooks/useRefferalData";
type ProductsFilterProps = {
  onChange: (value: string) => void;
  value?: string;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const RefferalsFilter: React.FC<ProductsFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
 
  const refferals = useRefferalData();
  const refferalsOptions = refferals?.data?.list.map(
    (refferal) => ({
      value: refferal.code,
      label: refferal.name,
    })
  );

  return (
    <SelectBoxWrapper>
    <Select
      allowClear
      placeholder={t("licenses.basic.search.refferal.title")}
      style={{ width: "100%", minWidth: 150 }}
      maxTagCount={1}
      options={refferalsOptions}
      onChange={onChange}
      value={value}
    />
    </SelectBoxWrapper>
  );
};
